import { Component, Input, OnInit } from '@angular/core';
import { PermitCounts } from 'src/app/core/interfaces/status-counts/permit-counts';

@Component({
  selector: 'app-permit-counts',
  templateUrl: './permit-counts.component.html',
  styleUrls: ['./permit-counts.component.scss'],
})
export class PermitCountsComponent implements OnInit {
  @Input() permitCounts: PermitCounts;

  constructor() {}

  ngOnInit(): void {}
}
